import { useThemeStore } from '../../state/theme';

export const BtnDefault: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    icon?: React.ReactNode;
  }
> = ({ children, icon, ...props }) => {
  const { isDarkMode } = useThemeStore();
  return (
    <button
      {...props}
      className={`flex items-center gap-2 px-3 py-1 text-sm font-normal rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ${
        isDarkMode
          ? 'text-gray-200 bg-gray-700 hover:bg-gray-600 focus:ring-gray-500'
          : 'text-blackTen bg-white border border-greyFourty hover:bg-greyTwenty focus:ring-blue-500'
      } ${props.className}`}
    >
      {icon && icon}
      {children}
    </button>
  );
};

export const BtnPrimary: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ children, ...props }) => {
  const { isDarkMode } = useThemeStore();

  return (
    <button
      {...props}
      className={`${isDarkMode ? 'bg-blue-600 hover:bg-blue-500' : 'bg-blue-600 hover:bg-blue-500'} w-fit text-white text-sm px-4 py-1.5 rounded-md ${props.className}`}
    >
      {children}
    </button>
  );
};

export const BtnDanger: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ children, ...props }) => {
  const { isDarkMode } = useThemeStore();

  return (
    <button
      {...props}
      className={`${isDarkMode ? 'bg-red-600 hover:bg-red-700' : 'bg-red-600 hover:bg-red-500'} w-fit text-white text-sm px-4 py-1.5 rounded-md ${props.className}`}
    >
      {children}
    </button>
  );
};
